<div class="dialog">
    <div fxLayout="column" fxLayoutAlign="center center">
        <img alt="success" src="../../../../assets/images/gif-1.gif" width="252px" fxFlexAlign="center">
        <p class=" txtCenter" style="color:rgb(5, 133, 5); margin:5px 0px; line-height:20px;" fxFlexAlign="center">{{Result}} !</p>
    </div>
</div>


